<script setup lang="ts">
interface Props {
  accordion?: boolean;
  outsideClose?: boolean;
}

const { accordion = false, outsideClose = false } = defineProps<Props>()

let activeState: Ref<boolean> | null = null

const setState = (state: Ref<boolean>, value: boolean) => {
  if (!accordion) {
    state.value = value
    return
  }

  if (!activeState) {
    activeState = state
  }

  if (activeState === state) {
    activeState.value = value
    return
  }

  activeState.value = false
  activeState = state
  activeState.value = value
}


const toggleState = (state: Ref<boolean>) => {
  if (!accordion) {
    state.value = !state.value
    return
  }

  if (!activeState) {
    activeState = state
  }

  if (activeState === state) {
    activeState.value = !activeState.value
    return
  }

  activeState.value = false
  activeState = state
  activeState.value = true
}

const init = (state: Ref<boolean>) => {
  if (!accordion) {
    return
  }

  if (activeState) {
    state.value = false
    return
  }

  if (state.value) {
    activeState = state
  }
}

const destroy = (state: Ref<boolean>) => {
  if (!accordion) {
    return
  }

  if (activeState === state) {
    activeState = null
  }
}

provide(DisclosureGroupInjection, {
  toggleState,
  setState,
  init,
  destroy,
  outsideClose
})
</script>

<template>
  <slot />
</template>